import { Metric } from 'web-vitals';

import { env } from 'utils/env';

const sendToData = function (data: Metric) {
  if (env.STAGE !== 'prod') {
    console.info(data);
  }
};

const reportWebVitals = () => {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(sendToData);
    getFID(sendToData);
    getFCP(sendToData);
    getLCP(sendToData);
    getTTFB(sendToData);
  });
};

export default reportWebVitals;
